import type { JSX } from 'react'

export const SettingsSolidIcon = (): JSX.Element => (
  <use href='#settingsSolidIcon' height='100%' width='100%' />
)
